import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CoreClass } from '@src/app/core/base/core.class';

@Component({
  selector: 'app-warning-block',
  templateUrl: './warning-block.component.html',
  styleUrl: './warning-block.component.scss',
  standalone: true,
  imports : [CommonModule]
})
export class WarningBlockComponent extends CoreClass {
  @Input() heading: string | null = ''
  @Input() message: string | null = ''
  @Input() containerStyle?: string | null = ''
  @Input() msgBodyStyle?: string | null = ''
  @Input() isWarning? : Boolean = false;
  @Output() hideAction: EventEmitter<any> = new EventEmitter();

  hide() {
    this.hideAction.emit();
  }
}
